import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../utils/PropTypesDefinitions'
import { BackgroundColorTypes } from '../../Theme/Fonts/FontTypes'

type SingleButtonAlert = {
    /** first button component */
    primaryButton?: ReactElement
    /** second button component */
    secondaryButton?: never
}

type TwoButtonAlert = {
    /** first button component, is required if second button is set */
    primaryButton: ReactElement
    /** second button component */
    secondaryButton?: ReactElement
}

export type AlertProps = {
    /** text component */
    text: ReactElement
    /** space button components, small means 4px, big means 8px */
    buttonSpaceBetween?: 'small' | 'big'
    /** backgroundColor of the whole component */
    backgroundColor?: BackgroundColorTypes
} & (SingleButtonAlert | TwoButtonAlert) &
    TestID

const Alert: FunctionComponent<AlertProps> = ({
    text,
    primaryButton,
    secondaryButton,
    buttonSpaceBetween = 'small',
    backgroundColor = 'onyx-opacity-70',
    testID,
}): ReactElement => {
    return (
        <Grid
            horizontal
            noExpand
            testID={testID}
            backgroundColor={backgroundColor}
            borderRadius={4}
            padding={6}
        >
            <Grid noExpand width="100%">
                {text}
                {primaryButton ? (
                    <Grid marginTop={6} noExpand>
                        {primaryButton}
                        {secondaryButton ? (
                            <Grid marginTop={buttonSpaceBetween === 'small' ? 2 : 3} noExpand>
                                {secondaryButton}
                            </Grid>
                        ) : null}
                    </Grid>
                ) : null}
            </Grid>
        </Grid>
    )
}

export default Alert
